import { Billing } from '@/services/api';
import { useAuth } from '@/services/auth';
import { ERROR_KINDS, moderationError as _moderationError } from '@/state/layout/moderation';
import { PlanGroup } from '@d-id/types';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import { ImageModeration } from '../components/modals/ImageModeration';
import PostCheckout from '../components/modals/PostCheckout';
import ScriptModeration from '../components/modals/ScriptModeration';

export const ModerationModal = () => {
    const resetError = useResetRecoilState(_moderationError);
    const moderationError = useRecoilValue(_moderationError);
    const params = useSearchParams()[0];
    const purchase = params.get('purchase');
    const navigate = useNavigate();
    const { user } = useAuth();

    switch (moderationError.kind) {
        case ERROR_KINDS.CelebrityDetectedError:
        case ERROR_KINDS.ImageModerationError:
            return <ImageModeration image={moderationError.extraData} onClose={resetError} kind={moderationError.kind} />;
        case ERROR_KINDS.TextModerationError:
        case ERROR_KINDS.AudioModerationError:
            return (
                <ScriptModeration
                    violationType={moderationError.kind === ERROR_KINDS.TextModerationError ? 'text' : 'audio'}
                    violations={moderationError.extraData}
                    onClose={resetError}
                />
            );
        default:
            if (purchase === 'success') {
                return (
                    <PostCheckout
                        onClose={() => navigate(window.location.pathname)}
                        isNewSubscription
                        requestedPriceId={params.get('price_id')!}
                        requestedPlan={params.get('plan')! as PlanGroup}
                        requestedBilling={(params.get('billing') || user?.billingInterval) as Billing}
                    />
                );
            }
    }
    return null;
};
